import { Department } from './../hooks/use-get-profile';
import { Experience, Profile } from "../hooks/use-get-profile";
import {
    ABOUT_ME_FORM_ONE_DATA_TYPE,
    ABOUT_ME_FORM_TWO_DATA_TYPE,
    ABOUT_ME_FORM_TYPE,
    NBLocationDetails,
} from "../modules/about-me/about-me.types";
import { ABOUT_ME_INTIAL_VALUE } from "../modules/about-me/constants/about-me.contants";
import { transformDataToAboutFormData } from "../modules/about-me/utils/about-me.helpers";
import { STEP_ONE_INITIAL_VALUES } from "../modules/education/constants/step-one.constants";
import { EducationInitialValues } from "../modules/education/education.types";
import { transformBodyToEducationForm } from "../modules/education/utils/education.utils";
import { EXPERIENCE_STEP_TWO_INITIAL_VALUES } from "../modules/experience/constants/step-two-constants";
import {
    ExperienceStepOneInitialValues,
    ExperienceStepTwoInitialValues
} from "../modules/experience/types/experience.types";
import { transformBodyToExperienceForm } from "../modules/experience/utils/body-to-form-data";
import { PREFERENCES_DEFAULT_VALUE } from "../modules/preferences/constants/preferences-constants";
import { PreferencesFormDeliveryDataType } from "../modules/preferences/types/assessment-types";
import { JobTypePref, PREFERENCE_FORM_TYPE, PreferredRole } from "../modules/preferences/types/preferences.types";
import { CategoryType } from "../modules/preferences/types/step-five-types";
import { CityType, NBPreferredLocationData } from "../modules/preferences/types/step-four-types";
import { PreferencesFormThreeDataType } from "../modules/preferences/types/step-three-types";
import { transformBodyToPreferencesForm } from "../modules/preferences/utils/preference.helper";
import createStore from "./utils/create-store";
interface IOnboardingStore {
    aboutMe: ABOUT_ME_FORM_TYPE;
    education: EducationInitialValues;
    preferences: PREFERENCE_FORM_TYPE;
    jobTypesDetails: JobTypePref[];
    preferredRoles: PreferredRole[];
    appConfig: Record<string, any>;
    preferencesConfig: Record<string, any>;
    setPreferredRoles: (roles: PreferredRole[]) => void;
    setAboutMeData: (
        i: string,
        o: ABOUT_ME_FORM_ONE_DATA_TYPE | ABOUT_ME_FORM_TWO_DATA_TYPE | NBLocationDetails | boolean
    ) => void;
    fetchedProfile?: Profile;
    setFetchedProfile: (profile: Profile) => void;
    setPreferenceData: (i: string, o: any) => void;
    experience: {
        id?: string | null;
        stepOne: ExperienceStepOneInitialValues;
        stepTwo: ExperienceStepTwoInitialValues;
    };
    allExperiences?: Experience[];
    latestExperience: ExperienceStepTwoInitialValues & {id?: string },
    setEducationId: (educationId: string) => void;
    setEducationData: (educationData: EducationInitialValues) => void;
    setExperienceData: (experienceData: {
        stepOne: any;
        stepTwo: ExperienceStepTwoInitialValues;
    }) => void;
    setExperienceId: (expereinceId: string | null) => void;
    setLatestExperienceData: (
        experienceData: ExperienceStepTwoInitialValues & {id?: string}) => void;
    setLatestExperienceDataId: (expereinceId: string) => void;
    setPreferencesJobCategories: (jobCategories: CategoryType[]) => void;
    setPreferredJobCityData: (city: CityType[]) => void;
    setPreferredNBJobCityData: (nbPrefCities: NBPreferredLocationData[]) => void;
    setTelecallerAssessmentDetails: (telecaller: string[]) => void;
    setDeliveryAssessmentDetails: (delivery: PreferencesFormDeliveryDataType) => void
    profileImageUrl?: string;
    setPhotoObject: (profileImageUrl: string) => void;
    setWorkTypePreferences: (workTypePreferences: PreferencesFormThreeDataType) => void;
    resume?: Profile["resume"];
    setJobTypesPreferences: (data: JobTypePref[]) => void;
    setEmail: (email: string) => void;
    setConfig: (config: Record<string, any>) => void;
    setPreferencesConfig: (config: Record<string, any>) => void;
    setResumeParsingFlow: (isResumeParsingFlow: boolean) => void;
    setTopDepartment:any;
    topDeparment:string[];
    setTopIndustry:any;
    topIndustry:string[];
    isResumeParsingFlow:boolean;
    isEmailFetchedFromTrueCaller?: boolean;
    setTrueCallerEmail: (isEmailFetchedFromTrueCaller: boolean) => void;
    emailFetchedFromTrueCaller?: string;
    setEmailFetchedFromTrueCaller: (email: string) => void;
}

export const useOnboardingStore = createStore<IOnboardingStore>((set) => {
    return {
        aboutMe: { ...ABOUT_ME_INTIAL_VALUE },
        education: { ...STEP_ONE_INITIAL_VALUES } as EducationInitialValues,
        experience: {
            id: null,
            stepOne: {
                hasWorkExperience: null as unknown as boolean,
                yearsOfExperience: null as unknown as number,
                monthsOfExperience: null as unknown as number,
            } as ExperienceStepOneInitialValues,
            stepTwo: {
                ...EXPERIENCE_STEP_TWO_INITIAL_VALUES,
            } as ExperienceStepTwoInitialValues,
        },
        latestExperience: {} as ExperienceStepTwoInitialValues & {id?: string },
        preferences: PREFERENCES_DEFAULT_VALUE,
        fetchedProfile: undefined,
        resume:undefined,
        jobTypesDetails: [],
        preferredRoles:[],
        appConfig: {},
        topDeparment:[],
        topIndustry:[],
        preferencesConfig: {},
        isResumeParsingFlow: false,
        isEmailFetchedFromTrueCaller: false,
        emailFetchedFromTrueCaller: "",
        setFetchedProfile: (data: Profile) =>
            set((state) => {
                const educationData = transformBodyToEducationForm(data);
                const aboutMeData = transformDataToAboutFormData(data as any);
                const preferencesData = transformBodyToPreferencesForm(data);
                // TODO: set entire experience data in one go
                const {
                    stepTwo: experienceStepTwo,
                    stepOne: experienceStepOne,
                    id: experienceId,
                    latestExpereince,
                    allExperiences
                } = transformBodyToExperienceForm(data);
                state.fetchedProfile = data;
                state.aboutMe = aboutMeData;
                state.education = educationData;
                state.preferences = preferencesData;
                state.experience.stepTwo = experienceStepTwo;
                state.experience.stepOne = experienceStepOne;
                state.latestExperience = latestExpereince;
                state.experience.id = experienceId;
                state.profileImageUrl = data?.photo?.url || "";
                state.resume = data?.resume;
                state.allExperiences = allExperiences || []
            }),
        setAboutMeData: (
            step: string,
            data: ABOUT_ME_FORM_ONE_DATA_TYPE | ABOUT_ME_FORM_TWO_DATA_TYPE | NBLocationDetails | boolean
        ) =>
            set((state) => ({
                aboutMe: {
                    ...state.aboutMe,
                    [step]: data,
                },
            })),
        setEducationData: (data: EducationInitialValues) => {
            set((state) => {
                state.education = data;
            });
        },
        setEducationId: (educationId: string) => {
            set((state) => {
                state.education.id = educationId;
            });
        },
        setPreferenceData: (step: string, data: any) =>
            set((state: any) => ({
                preferences: {
                    ...state.preferences,
                    [step]: data,
                },
            })),
        setExperienceData: ({ stepOne, stepTwo }) => {
            set((state) => {
                state.experience.stepTwo = stepTwo;
                state.experience.stepOne = stepOne;
            });
        },
        setExperienceId: (experienceId: string | null) => {
            set((state) => {
                state.experience.id = experienceId;
            });
        },
        setLatestExperienceData: (experienceData: any) => {
            set((state) => {
                state.latestExperience = experienceData;
            })
        },
        setLatestExperienceDataId: (experienceId: string) => {
            set((state) => {
                state.latestExperience = {...state.latestExperience, id: experienceId};
            });
        },
        setPreferencesJobCategories: (jobCategories: CategoryType[]) => {
            set((state) => {
                state.preferences.jobCategoryDetails.jobCategories = [...jobCategories];
            });
        },
        setPreferredJobCityData: (city: CityType[]) => {
            set((state) => {
                state.preferences.preferredJobCity = city;
            });
        },
        setPreferredNBJobCityData: (nbPrefCities: NBPreferredLocationData[]) => {
            set((state) => {
                state.preferences.nbPreferredJobCity = nbPrefCities;
            });
        },
        setTelecallerAssessmentDetails: (telecaller: string[]) => {
            set((state) => {
                state.preferences.assessmentDetails.telecaller = [...telecaller];
            });
        },
        setDeliveryAssessmentDetails: (delivery: PreferencesFormDeliveryDataType) => {
            set((state) => {
                state.preferences.assessmentDetails.delivery = { ...delivery };
            });
        },
        setPhotoObject: (profileImageUrl: string) => {
            set((state) => {
                state.profileImageUrl = profileImageUrl;
            });
        },
        setWorkTypePreferences: (workTypePreferences: PreferencesFormThreeDataType) => {
            set((state) => {
                state.preferences.workTypePreferences = workTypePreferences
            });
        },
        setJobTypesPreferences: (data: JobTypePref[]) => {
            set((state) => {
                state.jobTypesDetails = data
            })
        },
        setEmail: (email: string) => {
            set((state) => {
                state.aboutMe.personalDetails.email = email
            })
        },
        setPreferredRoles: (roles: PreferredRole[]) => {
            set((state) => {
                state.preferredRoles = roles
            })
        },
        setConfig: (config: Record<string, any>) => {
            set((state) => {
                state.appConfig = config
            })
        },
        setPreferencesConfig: (config: Record<string, any>) => {
            set((state) => {
                const currentConfig = state.preferencesConfig;
                state.preferencesConfig = { ...currentConfig, ...config};
            })
        },
        setTopDepartment:(dept:any) =>{
            set((state) => { 
               state.topDeparment = dept
            })
        },
        setTopIndustry:(industry:any) =>{
            set((state) => { 
               state.topIndustry = industry
            })
        },
        setResumeParsingFlow:(isResumeparsingFlow:boolean) =>{
            set((state) => { 
               state.isResumeParsingFlow = isResumeparsingFlow
            })
        },
        setTrueCallerEmail: (isEmailFetchedFromTrueCaller: boolean) => {
            set((state) => {
                state.isEmailFetchedFromTrueCaller = isEmailFetchedFromTrueCaller
            })
        },
        setEmailFetchedFromTrueCaller: (email: string) => {
            set((state) => {
                state.emailFetchedFromTrueCaller = email
            })
        }
    };
});
